import ButtonStackWidget from './ButtonStackWidget';
import { GALLERY } from "@mm/constants/widgets";

export default class GalleryWidget extends ButtonStackWidget {
  static make(pageId, sortOrder) {
    const widget = {
      ...super.make(pageId, GALLERY, sortOrder),
    };

    delete widget.label;

    return {
      ...widget,
      config: {
        ...widget.config,
        entries: [],
      },
    };
  }
}
